module.exports = __webpack_public_path__ + "static/media/master.85926d70.png";